import api from './api'

const settingsService = {
  // Get public settings (accessible without authentication)
  getPublicSettings: async (category = null) => {
    const params = category ? { category } : {}
    const response = await api.get('/settings/public', { params })
    return response.data
  },

  // Get all settings (admin only)
  getAllSettings: async (category = null) => {
    const params = category ? { category } : {}
    const response = await api.get('/settings', { params })
    return response.data
  },

  // Update single setting (admin only)
  updateSetting: async (key, value) => {
    const response = await api.put(`/settings/${key}`, { value })
    return response.data
  },

  // Update multiple settings (admin only)
  updateMultipleSettings: async (settings) => {
    const response = await api.put('/settings/bulk', { settings })
    return response.data
  },

  // Create new setting (admin only)
  createSetting: async (settingData) => {
    const response = await api.post('/settings', settingData)
    return response.data
  },

  // Delete setting (admin only)
  deleteSetting: async (key) => {
    const response = await api.delete(`/settings/${key}`)
    return response.data
  },
}

export default settingsService
